import React, { useState, useEffect } from "react";
import ReactConfetti from "react-confetti";
import "./App.css";

const reactions = [
  { emoji: "😢", text: "Ohh, what?" },
  { emoji: "😡", text: "Who am I supposed to eat Halohalo with??" },
  { emoji: "😒", text: "Do it for the lore?" },
  { emoji: "🤔", text: "I could technically eat all the ube icecream myself?" },
  { emoji: "🤨", text: "Kinda sus reaction" },
  { emoji: "🙄", text: "smhhhh" },
  { emoji: "😑", text: "aight bet" },
];

// Celebration page with collage, music and confetti
function CelebrationPage() {
  function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function getRandomPhotos() {
    const photoCount = 16;
    const selectedPhotos = [];
    for (let i = 1; i <= photoCount; i++) {
      selectedPhotos.push(`./images/${i}.jpeg`);
    }

    for (let i = 1; i <= photoCount; i++) {
      selectedPhotos.push(`./images/${i}.jpeg`);
    }
    return selectedPhotos;
  }

  function FloatingPhotos() {
    const [photos, setPhotos] = useState([]);

    useEffect(() => {
      setPhotos(getRandomPhotos());
    }, []);

    return (
      <div className="floating-photos">
        {photos.map((photo, index) => (
          <img
            key={index}
            src={photo} // Use the photo path from the array
            alt={`Floating ${index}`}
            style={{
              position: "absolute",
              top: `${getRandomInt(-20, 100)}%`,
              left: `${getRandomInt(-20, 100)}%`,
              transform: `rotate(${getRandomInt(-45, 45)}deg)`,
              width: `${getRandomInt(50, 150)}px`,
            }}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="celebration">
      {/* Confetti */}
      <ReactConfetti />
      <div className="text-container">
        <h1
          style={{
            fontSize: "5rem",
          }}
        >
          HUYYY!
        </h1>
        <h1>DAZZ + CHARLES 🥰</h1>
        <p style={{ paddingTop: "5rem"}}>p.s. I can't wait for all our crazy adventures.</p>

      </div>

      <div className="overlay"></div>

      <FloatingPhotos />

      {/* Background music */}
      <audio autoPlay loop>
        <source src="stargazing.mp3" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
    </div>
  );
}

function App() {
  const [answer, setAnswer] = useState(null);
  const [yesSize, setYesSize] = useState(1);
  const [reaction, setReaction] = useState("🥰");
  const [reactionText, setReactionText] = useState(null);

  const handleNoClick = () => {
    const randomReaction =
      reactions[Math.floor(Math.random() * reactions.length)];
    setReaction(randomReaction.emoji);
    setReactionText(randomReaction.text);
    setYesSize((prev) => prev + 0.2);
  };

  if (answer === "yes") {
    return <CelebrationPage />;
  }

  return (
    <div className="question">
      {reactionText && <p>{reactionText}</p>}
      <p className="emoji">{reaction}</p>
      <div className="text-container">
        <p>
          <strong>Dazzlyn Chua</strong>,
        </p>
        <p>will you be my valentine?</p>
      </div>
      <div className="buttons">
        <button
          onClick={() => setAnswer("yes")}
          className="yes"
          style={{ transform: `scale(${yesSize})` }}
        >
          Yes
        </button>
        <button className="no" onClick={handleNoClick}>
          No
        </button>
      </div>
    </div>
  );
}

export default App;
